import {
    HttpResponse,
    CodebookModel,
    QueryModel,
    RequestParams,
    CodebookModelIEnumerableApiResultSuccess,
    CodebookModelApiResultSuccess,
    ApiResultFailed,
    Operation,
    FullRequestParams,
    AggregationModel,
    AggregationResponse,
    GrouppedQueryModel
} from "@/libs/Api";
import ApiService from "@/libs/core/api-service"
import {CrudDataQuery} from '@/libs/core/crud/crud-query';
import {CrudService, CrudListResponse, CrudResponse, CrudPartialUpdatePatch} from '@/libs/core/crud/crud-service';

export class CodebooksDataService implements CrudService<CodebookModel, CodebookModel> {
    
    getAggregation(query: AggregationModel, params?: RequestParams): Promise<AggregationResponse> {
        throw new Error("Method not implemented.");
    }
    
    getGrouped(query: GrouppedQueryModel, params?: RequestParams): Promise<CrudResponse<any>> {
        throw new Error("Method not implemented.");
    }
    
    getAll(query: CrudDataQuery<CodebookModel>): Promise<CrudListResponse<CodebookModel>> {
        return ApiService.api.getCodebookBatch(query.pageIndex, query.pageSize, <any>query.data, query.params);
    }

    get(id: string, params?: RequestParams): Promise<CrudResponse<CodebookModel>> {
        return ApiService.api.getCodebookById(id, params);
    }

    create(item: CodebookModel, params?: RequestParams): Promise<CrudResponse<CodebookModel>> {
        return ApiService.api.insertCodebook(item, params);
    }

    update(item: CodebookModel, params?: RequestParams): Promise<CodebookModel> {
        return ApiService.api.updateCodebook(item.id as Required<string>, item, params).then((req: any) => req.data.returnValue);
    }

    partialUpdate(id: string, patches: Operation[], params?: RequestParams): Promise<CodebookModel> {
        return ApiService.api.patchCodebook(id, patches).then((req: any) => req.data.returnValue);
    }

    delete(query: CrudDataQuery<CodebookModel>): Promise<CrudListResponse<CodebookModel>> {
        return ApiService.api.deleteCodebooks(<any>query.data, query.params).then((req: any) => req.data.returnValue);
    }

    download(query: CrudDataQuery<CodebookModel>): Promise<HttpResponse<any, ApiResultFailed | void>> {
        throw "NotImplemented";
    }

}
